import { useContext } from 'react';
import { Grid } from '@mui/material';

import { useIsModuleDisabled } from 'app/main/components';
import { type FastAddDialogSettingsType } from 'app/main/modules/components/FastAddDialog';
import { DescriptionSection, InlineTitle } from 'app/main/modules/components/FastAddDialogSettingsManager';

import { AuthorizerContext } from 'app/providers/acl/AclProvider';

import InvoicesDetailsSectionInfo from './sections/InvoicesDetailsSectionInfo';
import InvoicesDetailsSectionRows from './sections/InvoicesDetailsSectionRows';
import InvoicesDetailsSectionDeadlines from './sections/InvoicesDetailsSectionDeadlines';

const InvoicesFastAddDialogContent: FastAddDialogSettingsType['content'] = props => {
	const isModuleDisabled = useIsModuleDisabled();
	const authorizer = useContext(AuthorizerContext);

	return (
		<>
			<InlineTitle text="DETAILS_INFO_SECTION" />
			<InvoicesDetailsSectionInfo {...props} />
			<InlineTitle text="DETAILS_DESCRIPTION_SECTION" />
			<DescriptionSection
				name="invc_descriptionhtml"
				value={props.model.invc_descriptionhtml}
				isEdit={props.isEdit}
				sendChange={props.sendChange}
			/>
			<InlineTitle text="INVOICES_ROWS_SECTION_TITLE" />
			<Grid size={12}>
				<InvoicesDetailsSectionRows {...props} />
			</Grid>
			{!isModuleDisabled('invoices-deadlines') && authorizer.can('view', 'invoices-deadlines') ? (
				<>
					<InlineTitle text="INVOICES_DEADLINES_SECTION_TITLE" />
					<Grid size={12}>
						<InvoicesDetailsSectionDeadlines {...props} />
					</Grid>
				</>
			) : (
				<></>
			)}
		</>
	);
};

const dialogSettings: FastAddDialogSettingsType = {
	content: InvoicesFastAddDialogContent
};

export default dialogSettings;
